import { Link2, FileText, ExternalLink } from "lucide-react";
import { AI_GAMES } from "../data/conferenceData";
import BackToMore from "../components/BackToMore";

export default function AIGames() {
  return (
    <div style={{ padding: "16px", paddingBottom: "40px" }} data-testid="ai-games-page">
      <BackToMore />
      <h2
        style={{
          fontSize: "22px",
          fontWeight: 800,
          color: "var(--primary-dark)",
          marginBottom: "4px",
        }}
      >
        AI Online Learning Games
      </h2>

      <div style={{ marginBottom: "24px", marginTop: "16px" }}>
        <div
          className="flex items-center"
          style={{ marginBottom: "10px", gap: "10px" }}
        >
          <div
            className="flex items-center justify-center"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              backgroundColor: "var(--primary)",
            }}
          >
            <Link2 size={20} color="white" strokeWidth={2} />
          </div>
          <p
            style={{
              fontSize: "16px",
              fontWeight: 800,
              color: "var(--primary-dark)",
            }}
          >
            Links
          </p>
        </div>

        {AI_GAMES.map((g) => (
          <a
            key={g.title}
            href={g.url}
            data-testid={`ai-game-${g.title}`}
            className="flex items-start"
            style={{
              backgroundColor: "var(--surface)",
              padding: "12px",
              borderRadius: "10px",
              marginBottom: "8px",
              border: "1px solid var(--border)",
              gap: "10px",
            }}
          >
            <FileText
              size={18}
              color="var(--primary)"
              style={{ marginTop: "2px", flexShrink: 0 }}
            />
            <div className="flex-1">
              <p
                style={{
                  color: "var(--primary-dark)",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "19px",
                }}
              >
                {g.title}
              </p>
              {g.description && (
                <p
                  style={{
                    color: "var(--text-muted)",
                    fontSize: "12px",
                    lineHeight: "17px",
                    marginTop: "4px",
                  }}
                >
                  {g.description}
                </p>
              )}
            </div>
            <ExternalLink
              size={16}
              color="var(--text-muted)"
              style={{ marginTop: "2px", flexShrink: 0 }}
            />
          </a>
        ))}
      </div>
    </div>
  );
}
